export const normalizeEmail = (email) => {
  if (!email) return null;

  const normalizedEmail = email.trim();
  
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
    return null;
  }

  return normalizedEmail;
};

export const normalizeMobile = (mobile) => {
  if (!mobile) return null;

  const digits = mobile.replace(/\D/g, '');

  if (!/^010\d{8}$/.test(digits)) {
    return null;
  }

  return `${digits.slice(0, 3)}${digits.slice(3, 7)}${digits.slice(7)}`;
};